const addHideReceiptListing = _ref => {
  let {
    types
  } = _ref;
  return payload => dispatch => {
    dispatch({
      type: types.ADD_HIDE_RECEIPT_LISTING,
      payload: {
        ...payload
      }
    });
  };
};
export default addHideReceiptListing;